﻿export default {
  name: "compte",
  methods: {
    isAuthorize(arrayRoles) {
      if (this.$user && this.$user.roles) {
        return this.$user.roles.some(role => arrayRoles.includes(role))
      }
      return false
    },
    isAuthorizeSeo() {
      if (this.$user && this.$user.roles) {
        return this.$user.roles.some(role => ["Admin"].includes(role))
      }
      return false
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/compte.js
// module id = fEKF
// module chunks = 18